<template>
    <div class="lmy-doc-detail">
        <div class="doc-title">龙猫游平台用户服务协议</div>
        <div class="doc-date">
          发布日期：2022年01月01日<br>生效时间：2022年03月01日
        </div>
        <div class="doc-content">
          <div class="text-bold text-gap">提示条款</div>
          <label class="text-bold">【审慎阅读】</label>您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。<label class="bold-underline">请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。重点条款将以粗体标识，您应仔细阅读。</label>如您对协议有任何疑问，可通过本协议中提供的联系方式咨询。<br><br>
          <label class="text-bold">【签约动作】</label>当您阅读并同意本协议进行下一步，即表示您已充分阅读、理解并接受本协议的全部内容，成为龙猫游平台的用户。<label class="bold-underline">阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止使用。</label><br><br>
          【服务协议的确认和接纳】<br>
          龙猫游平台由深圳市前海乐订会展服务有限公司运营，涉及具体的产品及/或服务（以下简称“产品/服务”），则由有资质的服务商提供。如果用户（以下或称“您”）访问龙猫游平台，预订或使用龙猫游平台的产品或服务，便视为您接受了《龙猫游平台用户服务协议》（以下简称 “本协议”）。请您仔细阅读以下内容，尤其是以下加粗字体。如果您不同意以下任何内容，请立刻停止访问龙猫游平台/使用龙猫游平台所提供的任何产品或服务。
          <div class="text-bold text-gap">1、总则</div>
          本协议内容包括协议正文、龙猫游平台子频道各单项服务协议及其他龙猫游平台已经发布的或将来可能发布的各类规则，包括但不限于免责声明、个人信息保护政策、个人信息授权声明、预订条款/预订须知、旅游合同、账户注销协议等其他协议（以下简称“其他条款”）。如果本协议与“其他条款”有不一致之处，则以“其他条款”为准。除另行明确声明的情形之外，任何龙猫游平台提供的产品/服务均受本协议约束。<br>
          本协议中，“龙猫游”是指包括龙猫游平台的开发者和运营者深圳市前海乐订会展服务有限公司及其关联公司在内的企业集团。“关联公司”指深圳市前海乐订会展服务有限公司旗下所有公司及其附属、关联公司，包括但不限于深圳市龙腾捷旅信息科技股份有限公司（CN Travel Group）旗下所有公司及其附属、关联公司，包括但不限于、深圳市港捷旅国际旅行社有限公司等。<br>
          本协议中，“龙猫游平台”包括但不限于App、微信公众号、微信小程序、百度小程序、支付宝小程序或H5页面等，客户端适用的终端设备包括但不限于PC、平板电脑、手机、电视等。<br>
          本协议中，“用户”指访问或使用龙猫游平台所提供的产品/服务的自然人，包括但不限于注册用户及未注册用户。凡未注册龙猫游平台的产品/服务的用户，自开始使用龙猫游平台的产品及/或服务时即成为我们的“非注册用户”，在使用过程中须遵循本协议中除注册用户专属约定以外的其他所有条款。<br>
          若您作为龙猫游或合作公司的用户访问龙猫游平台或使用龙猫游产品/服务，即视为您同意本协议的所有条款及龙猫游平台公布的其他条款、规则、说明和操作指引。
          <div class="text-bold text-gap">2、服务须知</div>
          龙猫游平台运用自己的操作系统通过国际互联网络为用户提供各类产品/服务。您必须：<br>
          （1）自行配置必要的上网设备，包括PC、手机、平板电脑，以及调制解调器、路由器等。<br>
          （2）个人上网和支付与此服务有关的网络费用、电话费用。<br>
          若选择移动设备，您须选择并安装与所上网设备相匹配的客户端版本，包括但不限于iOS、Android，或微信小程序等龙猫游平台发布的客户端。您可以从得到龙猫游授权的第三方应用平台获取。如果您从未经龙猫游授权的第三方获取与龙猫游平台客户端名称相同的安装程序，龙猫游无法保证该软件能够正常使用，并对因此给您造成的损失不予负责。<br>
          考虑到龙猫游平台提供的产品/服务的重要性，您同意：<br>
          （1）提供真实、详尽及准确的个人资料用于注册龙猫游平台账户，<label class="text-bold">不得使用他人邮箱、手机号码或以其他冒用他人身份的方式进行账号注册。</label><br>
          （2）在提交注册信息后，如果信息发生变化，您应及时更改。如果您提供的信息不符合合法、真实、准确、详尽的要求，您需承担因此引起的相应责任及后果，并且龙猫游平台保留终止您使用各项产品/服务的权利。
          <div class="text-bold text-gap">3、服务协议的修改</div>
          龙猫游平台会在必要时修改本协议及/或各类规则，并将在龙猫游平台相应页面提前公告。具体而言，龙猫游将通过适当的方式在平台上对本协议的修改事宜进行公告或通知，此类通知于公布或发送之日即视为已送达您。<br>
          龙猫游承诺，对于本协议及/或各类规则的修改，龙猫游平台应当于变更后的文本生效之日前至少七日进行公告或通知。如您不同意相关变更，应当立即停止访问龙猫游平台或使用龙猫游平台的产品/服务。若您在本协议及/或各类规则变更生效之日后继续使用龙猫游平台的产品/服务的，即表示您接受修订后的文本。
          <div class="text-bold text-gap">4、服务变更、中断、终止</div>
          您完全理解并同意，本服务涉及到互联网及移动通讯等服务，可能会受到各个环节不稳定因素的影响。因此任何因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机、GSM网络、互联网络、通信线路等其他龙猫游平台无法预测或控制的原因，造成服务中断、取消或终止的风险，由此给您带来的损失，龙猫游不承担赔偿责任。<br>
          龙猫游平台需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，如因此类情况而造成网络服务（包括收费网络服务）在合理时间内的中断，龙猫游无需为此承担任何责任，但龙猫游平台应尽可能事先进行通知。<br>
          您完全理解并同意，除本服务协议另有规定外，鉴于网络服务的特殊性，龙猫游平台有可能变更、中断或终止部分或全部的网络服务。<br>
          除了您已经通过龙猫游平台订购或申请的产品/服务并已完成支付并已获得确认订购或申请的情况之外，龙猫游平台无需为变更、中断或终止服务承担任何责任，但龙猫游平台应尽可能事先进行通知，并尽可能给您预留时间以便处理相关权益。
          <div class="text-bold text-gap">5、用户行为规范</div>
           <div class="text-bold">您在使用龙猫游平台产品/服务时，必须遵守中华人民共和国相关法律法规的规定，您承诺将不会利用龙猫游平台的产品/服务进行任何违法或不正当的活动，包括但不限于下列行为：</div>
          （1）上载、展示、张贴、传播或以其它方式传送含有下列内容之一的信息：<br>
          l 反对宪法所确定的基本原则的；<br>
          l 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br>
          l 损害国家荣誉和利益的；<br>
          l 煽动民族仇恨、民族歧视、破坏民族团结的；<br>
          l 破坏国家宗教政策，宣扬邪教和封建迷信的；<br>
          l 散布谣言，扰乱社会秩序，破坏社会稳定的；<br>
          l 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br>
          l 侮辱或者诽谤他人，侵害他人合法权利的；<br>
          l 含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；<br>
          l 含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的。<br>
          （2）为任何非法目的而访问龙猫游平台或使用龙猫游产品/服务，或未经允许，利用龙猫游平台从事以下活动：<br>
          l 未经允许，进入计算机信息网络或者非法获取、使用计算机信息网络资源的；<br>
          l 未经允许，对计算机信息网络功能进行删除、修改或者增加的；<br>
          l 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；<br>
          l 故意制作、传播计算机病毒等破坏性程序的；其他危害计算机信息网络安全的行为；<br>
          l 未经允许，将龙猫游平台上的任何数据作商业性利用，包括但不限于在未经龙猫游事先书面同意的情况下，以网络爬虫、复制、传播等任何方式获取、使用龙猫游平台上展示的资料；<br>
          l 使用任何装置、软件或例行程序等其他方式干预或试图干预龙猫游平台的正常运作或正在龙猫游平台上进行的任何交易、活动，或采取任何将导致不合理的庞大数据负载加诸龙猫游平台网络设备的行动；<br>
          l 违反诚实信用原则的不正当竞争行为，或恶意下订单或虚假交易等其他恶意扰乱龙猫游平台产品/服务交易秩序的行为；<br>
          l 与网上交易无关的其他行为，例如发布广告信息（得到龙猫游书面许可的除外）；<br>
          l 发布任何侵犯龙猫游平台或他人合法权益、违反法律法规及其他规范性文件（包括但不限于《互联网视听节目服务管理规定》、《网络信息内容生态治理规定》等）及本协议的内容。
          <div class="text-bold">上述行为的发生，将视为您对本协议的根本违约。在任何情况下，龙猫游平台一旦合理地认为您存在或可能存在上述行为的，可以在任何时候，不经事先通知删除您散布或传播的任何信息，并中止或终止向您提供龙猫游平台的产品/服务。您需对自己在访问龙猫游平台或使用龙猫游平台的产品/服务中的行为承担法律责任。您若在龙猫游平台散布或传播以上违反国家法律法规或公序良俗的信息，龙猫游平台的系统记录将有可能作为您违法犯罪的证据向有关部门提供。</div>
          <div class="text-bold text-gap">6、知识产权</div>
          龙猫游在龙猫游平台提供的相关产品/服务中使用或产生的内容（包括但不限于产品、软件、网页、文字、图片、音频、视频、数据、信息等）的知识产权归龙猫游所有。龙猫游所有和享有的知识产权，不因您的任何使用行为而发生权利转移。未经龙猫游事先书面明确同意，您不得以任何形式对前述内容进行使用或创造相关衍生作品，但如您是作品的权利人、您已获得相关权利人授权或龙猫游与您另有约定的除外。
          <br>
          您承诺，通过龙猫游平台发布上传的内容（包括但不限于文字、图片、视频、音频等各种形式的内容）为原创或已获合法授权，上传内容的知识产权归属于您本人或者相关权利人所有。您通过龙猫游平台上传发布的内容，由您自行承担责任。如您发送或传播的内容违法违规或侵犯他人权利的，龙猫游有权进行独立判断并采取删除、屏蔽或断开链接等措施。因侵犯他人知识产权而引发纠纷的，您须自行承担全部责任。如您的行为给龙猫游造成损失的，龙猫游有权按照法律规定要求您赔偿。<br>
          您承诺，针对您通过龙猫游平台上传、发布或传输的内容（包括但不限于产品、软件、网页、文字、图片、音频、视频、数据、信息等），您不可撤销地授予龙猫游、或龙猫游指定的第三方一项全球范围内、免费、非独家、可再许可的权利（包括但不限于复制、翻译、汇编、信息网络传播、改编、制作衍生品、表演、展示、放映、摄制、发行的权利，以及与上述权利相关的商业开发、宣传和推广等权利）。龙猫游对有关内容的使用范围包括但不限于在龙猫游平台或龙猫游指定的其他网站、应用程序、产品或终端设备等。<br>
          您确认并同意授权龙猫游以龙猫游自己的名义或委托专业第三方对侵犯您上传发布的享有知识产权的内容进行代维权，维权形式包括但不限于：监测侵权行为、发送维权函、提起诉讼或仲裁、调解、和解等，龙猫游平台有权对维权事宜做出决策并独立实施。
          <div class="text-bold text-gap">7、用户个人信息与隐私权保护</div>
          尊重用户个人信息以及隐私权是龙猫游平台的基本政策。在您使用龙猫游平台的产品/服务的过程中，龙猫游平台将采用相关技术措施及其他安全措施来保护您的个人信息与隐私权。<br>
          龙猫游平台非常注重未成年人的个人信息与隐私权保护，因此：<br>
          l 若您为未成年人，应在监护人监护、指导下阅读本协议，并且使用龙猫游的产品/服务已经得到监护人的同意；<br>
          l 若您是未成年人的监护人，应指导其上网应该注意的安全问题。若您同意未成年人使用龙猫游平台的产品/服务，必须以您名义申请交易或办理消费（如涉及），并对未成年人使用龙猫游平台的产品/服务进行正确引导、监督。<label class="text-bold">未成年人通过您的账户使用龙猫游平台的产品/服务，以及行使和履行本协议项下的权利和义务即视为已获得了您的认可。</label><br>
          更多关于个人信息处理和隐私权保护的规则、用户对个人信息的控制权、未成年人个人信息处理和隐私权保护等内容，请您通过龙猫游平台查阅龙猫游《个人信息保护政策》与《儿童个人信息保护规则及监护人须知》的全文。
          <div class="text-bold text-gap">8、龙猫游平台账户注册</div>
          您确认，在您开始注册使用龙猫游平台的产品/服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。<br>
          您可以创建一个龙猫游平台账户来使用龙猫游平台的产品/服务。您可以直接在龙猫游平台使用您的手机号注册，亦可通过龙猫游平台所支持的第三方账号（如QQ/微信/微博/百度/支付宝等账号）授权登录方式直接登录。<br>
          在成功注册龙猫游平台账号后，您亦可通过授权登录等方式使用龙猫游平台账户登录龙猫游的部分合作方的产品/服务。但请您注意，您通过龙猫游平台账号登录与合作方的产品/服务的，应当同时遵守相关合作方的账号使用规则。<br>
          除通过以上第三方账号授权登录外，您仅可通过龙猫游平台官方提供的渠道注册龙猫游平台账户。您不得通过包括但不限于购买、租用、借用、分享、利用或破坏我们的注册系统及/或其他未经我们许可的方式获得龙猫游平台账户。<br>
          <label class="text-bold">您享有龙猫游平台账户的有限使用权，您的账户仅可为个人出于非商业目的进行使用, 不得以转让、出租、出借、售卖、分享或其他任何方式交由他人使用</label>（但法律另有规定或龙猫游明确书面同意或授权的除外）。<br>
          如有证据证明或龙猫游根据龙猫游平台规则判断您存在不当注册或不当使用多个龙猫游平台账户的情形，龙猫游平台可采取冻结或关闭账户、取消订单、拒绝提供服务等措施，如给龙猫游平台及相关方造成损失的，您还应承担赔偿责任。<br>
          您在龙猫游平台开通的超级会员特权将与您的龙猫游平台账户绑定，您可以通过已绑定的龙猫游平台账户行使您的超级会员特权，但无法在其他账户下享有上述特权。
          <div class="text-bold text-gap">9、账户安全</div>
          根据页面提示注册成功后，您将得到一个龙猫游平台账户，并可根据密码规则自行设置账户密码。鉴于网络服务的特殊性，龙猫游无义务审核是否是您本人使用账户的用户名及密码。任何人只要输入的用户名及密码与数据库中保存的一致，即可凭借该组用户名及密码登录龙猫游平台账户，并使用龙猫游产品/服务。因此，请您对密码加以妥善保管，切勿将密码告知他人。如果您未能妥善保管密码，您将承担因此而导致或可能导致的全部责任。除龙猫游存在过错外，您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务等）负责。<br>
          您理解并同意，为使您更好地使用龙猫游平台的各项服务，保障您的账户安全，龙猫游可要求您按龙猫游平台规则以及相关法律法规规定完成实名认证。<br>
          另外，考虑到提供客户服务的便捷性，当用户使用在确认订单时向龙猫游平台提供的联系手机号拨打客服电话，龙猫游平台会通过核对订单信息的方式确认用户身份，并根据用户的要求对有关的订单执行相关操作。因此，请您妥善保管您的手机，设置必要的安全措施防止订单信息泄露。若非因龙猫游过错（例如您的手机失窃或您手机未设置必要的加密措施，致使龙猫游平台订单信息受到不法窥探，他人使用有关信息冒充您的身份使用龙猫游平台及客户服务等）导致订单信息外泄及其他后果的，即使您认为有关的行为并非您本人所为，龙猫游将不会承担因此而产生的任何责任。<br>
          您确认并同意，您对通过您的账户所进行的活动、行为和事件依法享有权利和承担责任。您不得以任何形式转让账户、授权他人使用您的账户以及与他人交易账户。如果您发现有人未经您的授权使用了您的龙猫游平台账户，或您的账户存在其他异常情况导致无法正常登录使用，您需要按照龙猫游平台提供的修改密码流程进行密码重置。在此过程中，龙猫游可能会要求您提供相应信息及/或证明资料，请确保您所提供的内容真实有效，否则将可能无法通过我们的验证而导致找回失败。您若发现任何非法使用用户账户或安全漏洞的情况，请立即根据本协议提供的联系方式通知龙猫游。
          <div class="text-bold text-gap">10、广告、第三方链接与商业营销</div>
          <div class="text-bold">您知悉并同意，龙猫游平台在提供产品/服务的过程中，在符合法律法规的前提下，保留以各种方式投放商业性广告（包括广告链接）或其他任何类型的商业信息的权利（包括但不限于在龙猫游平台的任何位置上投放广告，在您上传、传播的内容中投放广告）。</div>
          在符合法律法规的前提下，龙猫游平台有权自主决定广告投放的形式、时长、位置、内容而不受任何第三方的干预。
          <div class="text-bold">龙猫游平台的产品/服务可能会提供与其他互联网网站或资源进行链接，龙猫游会依照法律规定对广告商履行相关义务，但您知悉并同意，这些广告商和广告内容非由龙猫游控制，您对广告信息应审慎判断其真实性、可靠性。您通过龙猫游平台的产品/服务与广告商或广告主进行任何形式的行为或产生任何形式的纠纷，由您自行负责与解决，除法律法规规定由广告发布者承担的责任外，龙猫游不承担任何额外责任，但根据需要会依法提供必要的协助。</div>
          您在访问龙猫游平台或使用产品/服务的同时，同意接受龙猫游平台提供的各类信息推送服务，包括但不限于短信、龙猫游平台信息推送等服务类及营销类信息。
          <div class="text-bold text-gap">11、法律责任</div>
          龙猫游明确表示不提供任何类型的担保，不论是明确的或隐含的，但是不对商业性的隐含担保，特定目的和不违反规定的适当担保作限制。<br>
          对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，龙猫游并不承担相应的违约责任：<br>
          l 因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；<br>
          l 因电力供应故障、通讯网络故障等公共服务因素或第三方因素；<br>
          l 在龙猫游已尽善意管理责任的情形下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。<br>
          龙猫游不对任何来自用户不正当使用网络会员服务，非法使用服务或用户向龙猫游平台提供的信息有所变动造成的损害承担任何后果，因为龙猫游早已提出这些损害的可能性并要求用户加以防范。<br>
          在任何情况下，龙猫游不对任何间接损害（包括商誉损失、利润损失、收入损失、营业中断、缔约机会损失、预期利益损失，及其他间接的、随附性的、惩罚性的损失）承担赔偿责任。<br>
          若您在龙猫游平台上实施了违反本协议或其他单项服务协议、规则的行为，龙猫游平台可依据相应规则对您的账户执行扣减积分、限制参加营销活动、中止提供部分或全部服务、取消订单等处理措施。如您的行为构成根本违约的，龙猫游平台可冻结您的账户，终止提供服务。如您的行为使龙猫游遭受损失（包括直接经济损失和间接经济损失），或受到任何第三方的索赔，或受到有关行政部门的处罚，您应当承担全部的赔偿责任。<br>
          若有任何人声称您的行为损害第三方权益，并导致龙猫游或向龙猫游平台提供产品/服务的第三方遭受诉讼或其他纠纷的，您同意为龙猫游及/或上述第三方提供抗辩，且龙猫游保留自费进行独自抗辩和向您追索的权利。
          <div class="text-bold text-gap">12、法律</div>
          <div class="text-bold">本协议涉及的概念与界定，与中华人民共和国法律中的相同概念与界定一致。因通过龙猫游平台预订任何产品或使用任何服务而导致的争议，双方可协商解决；协商不成的，任何一方均可向上海市长宁区人民法院提起诉讼。</div>
          对于与龙猫游平台有关的纠纷，您知晓并完全同意对事实清楚、权利义务关系明确、争议不大、标的额为人民币一万元以上、十万元以下的简单金钱给付案件，使用小额诉讼程序，实行一审终审。使用小额诉讼程序审理的案件，审判组织、审理期限、审理方式、一审终审等相关事项以最高人民法院颁发的《民事诉讼程序繁简分流改革试点实施办法》为准。
          <div class="text-bold">13、联系方式</div>
          如您对本协议或使用龙猫游平台的产品/服务相关的事宜有任何问题（包括问题咨询、投诉等），我们专门为您提供了多种反馈通道，希望为您提供满意的解决方案：<br>
          l 人工客服电话通道：<a class="text-link" href='tel:010-56304887'>010-56304887</a>；<br>
          l 邮件通道：<a class="text-link" href='mailto:op-4@cnbooking.net'>op-4@cnbooking.net</a>；
          

        </div>


        <div class="text-bold"></div>
        <label class="text-bold"></label>
        <label class="text-link"></label>
        <label class="bold-underline"></label>

        <div >
           
           
        </div>
    </div>
</template>

<script>
    export default {
        name:'Service',
        data : {
        },
        methods : {
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/usr/docs/service.vue